export default class RippleEffectAction {
    constructor() {
        RippleEffectAction.init()
    }

    static init() {
        for (const rippleElement of document.querySelectorAll('.iris-ripple-effect')) {
            rippleElement.addEventListener('click', (e) => {
                const X = e.pageX - 2
                const Y = e.pageY - 4

                const rippleDiv = document.createElement('span')
                rippleDiv.classList.add('ripple')
                rippleDiv.setAttribute('style', `top:${Y}px; left:${X}px;`)
                document.querySelector('body').appendChild(rippleDiv)
                setTimeout(() => {
                    rippleDiv.remove()
                }, 900)
            })
        }
    }
}
